import { Formatter } from 'gf-ui';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';

const InputText = ({kid, item, domande, risposte_all, value, onChange}) => {    

  const [visibile, mostra] = useState(false)  
  const domanda = item.DESCRIZIONE;    
  const mostraSe = item.ARR_RIFERIMENTI;   
  const placeholder = item.ARR_RISPOSTE[0].DESCRIZIONE;

  const selVal = (val) => {                
    onChange(kid, val)            
  }
  
  useEffect(()=>{             
    if( mostraSe.length === 0 ){
      mostra(true);
    }else{        
      let mostraDomanda = false;      
      Object.keys(mostraSe).forEach( idx => {
        const domanda_rif = mostraSe[idx];                                
        if( risposte_all.indexOf(domanda_rif.ID_MA_CSS_D_R) >= 0 ){
          mostraDomanda = true;
        }               
      })
      mostra(mostraDomanda)
    }    
  }, [domande, mostraSe, risposte_all])  

  useEffect(()=>{
    if(!visibile && !Formatter.isStringaVuota(value)){      
      onChange(kid, null)
    }
  }, [kid, onChange, value, visibile])

  return (
    <>      
      { visibile && (
      <Form.Group className="mb-3 form-group bg-white">
        <div className={`form-control p-0 bg-white`} style={{border: `1px solid ${value?'green':'lightgrey'}`, borderRadius: '10px'}}>
          <div className={`form-control ${(value !== undefined && value !== "") ? "is-valid" : ""}`} style={{border: 'none', borderRadius: '10px'}}>
            <div className='form-label fw-bold' dangerouslySetInnerHTML={{__html: domanda}} />
          </div>
          <div className='px-4 pb-4'>
            <Form.Control as="textarea"                      
                          rows={4}                    
                          aria-label={domanda}                     
                          onChange={(e) => selVal(e.target.value)}
                          value={value} 
                          placeholder={placeholder}
                          required={item.FLG_OBBLIGATORIA==="-1"}  
                          maxLength={1000}                                                                 
                          />      
          </div>
          
        </div>
      </Form.Group>
      )}
    </>
  )
}

export default InputText;